import React, { Component } from "react";
import { Container, Input } from "reactstrap";
import { FormattedMessage, injectIntl } from "react-intl";
import { withRouter } from 'react-router-dom';
import { toast } from "react-toastify";
import debounce from 'lodash/debounce'
import { handlePublicRequestError, Request } from '../../helpers/request'
import { businessUnitOptions } from '../../helpers/select'
import BusinessUnitButton
    from "../../components/portfolio/JobsPage/BusinessUnitButton";
import CKContent from "../../components/CKContent";
import Button from "../../components/form/Button";
import { detectLanguage } from "../../helpers/i18n";
import { addLocalePrefix } from '../../components/Routes/LocaleLink'

class TopProfilesPage extends Component {
    state = {
        business_unit: null,
        email: null,
        data: [],
        business_unit_options: [],
        loading: false,
        ready: false,
    };

    componentDidMount() {
        if (!this.props.match.params?.business_unit) {
            this.props.history.replace(addLocalePrefix(`/top-profiles/tech`))
            return
        }
        this.fetch(false);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.match.params?.business_unit !== this.props.match.params?.business_unit) {
            this.fetch(false)
        }
    }

    fetch = debounce((concat = true, offset = null) => {
        this.setState({
            loading: true,
            business_unit: this.props.match.params?.business_unit ?? 'tech'
        });

        let fullUri = `top-profiles/${this.state.business_unit}/show`
        Request.get(fullUri)
            .then((response) => {
                const { intl } = this.props;
                const { data } = this.state;

                this.setState({
                    data: concat ? data.concat(response.page) : response.page,
                    business_unit_options: response.business_unit_options,
                    loading: false,
                    ready: true,
                }, () => offset ? window.scrollTo(0, offset) : null);
            })
            .catch((e) => {
                handlePublicRequestError(e);
                this.setState({ loading: false });
            });
    }, 400);

    renderTopProfiles() {
        return (<div>
            {
                this.state.data.top_profiles.map((profile) => {
                    return this.renderTopProfile(profile);
                })
            }
        </div>)
    }

    mailTo = (e) => {

        const { intl } = this.props;
        const data = {
            email: this.state.email
        }

        const success = intl.formatMessage({
            id:"portfolio.top_profiles.newsletter.registration_success",
            defaultMessage:"email ajouté à la newsletter"
        });

        Request.post('top-profile-newsletter/register-email', data)
            .then((data) => {
                toast.success(
                    intl.formatMessage({
                        id: "portfolio.top_profiles.newsletter.registration_success",
                        defaultMessage: "email ajouté à la newsletter"
                    })
                );
            }).catch((err) => {
                if(err.errors?.email) {
                    toast.error(err.errors.email.join(','));
                } else {
                    if (err.message) {
                        console.error(err.message);
                    }
                    return toast.error('Server Error');
                }
            });
    }

    renderSkills(skills) {
        return skills.map((skill, index) => {
            return (
                <div key={index}>
                    {skill}
                </div>
            )
        })
    }

    renderConsultant(profile) {
        const consultant = profile?.consultant

        return (
            <div className="top-profile-consultant">
                <div className="top-profile-consultant-card">
                    <figure >
                        <img className={'team-image'}
                             src={consultant.attachment
                                 ? consultant.attachment.url
                                 : `https://via.placeholder.com/150.png/070014/fff?text=${consultant.firstname}`}
                             style={{maxHeight: '190px'}}
                             alt="img" />
                        <div className={'filter'}></div>
                    </figure>
                    <div className="top-profile-consultant-name">
                        <h2>{
                            <FormattedMessage
                                id="portfolio.top_profiles.opinion"
                                values={{name: consultant.firstname}}
                                defaultMessage={""}
                            />}
                        </h2>
                    </div>
                    <div className="top-profile-consultant-comment">
                        <CKContent data={profile.consultant_comment} className="blog-text-inner" />
                    </div>
                </div>
                <div>
                    <a className="btn btn-line-danger" href={`mailto:${consultant.email}`}>
                        <FormattedMessage
                            id="portfolio.top_profiles.mail_to"
                            defaultMessage="Je suis intéressé par ce profil"
                        />
                    </a>
                </div>
            </div>
        )
    }

    renderTopProfile(profile) {
        const skillsToArray = (profile.skills) ? profile.skills.split(',') : []

        return (
            <div key={profile.id} className="top-profile">
                <div className="profile">
                    <div className="top-profile-title">
                        <h2>{profile.title}</h2>
                    </div>
                    <div className="top-profile-content">
                        <CKContent data={profile.content} className="blog-text-inner" />
                    </div>
                    <div className="top-profile-salary-expectation">
                        <h3>
                            <FormattedMessage
                                id="portfolio.top_profiles.salary_expectation"
                                defaultMessage="Prétentions Salariales"
                            />
                        </h3>
                        {profile.salary_expectation}
                    </div>
                    <div className="top-profile-location">
                        <h3>
                            <FormattedMessage
                                id="portfolio.top_profiles.location"
                                defaultMessage="Localisation recherchée"
                            />
                        </h3>
                        {profile.location}
                    </div>
                    <div className="top-profile-skills">
                        {this.renderSkills(skillsToArray)}
                    </div>
                </div>

                {/*Consultant*/}
                <div className="consultant">
                    {this.renderConsultant(profile)}
                </div>
            </div>
        )
    }



    render() {
        const { intl } = this.props;
        const { email } = this.state;
        const locale = detectLanguage()
        const translationKey = this.props.match?.params?.business_unit ?? 'tech'

        return (
            <div className="top-profiles-page">
                <div id="business-categories-options-menu"
                     className="react-select-container" />

                    <section className="top-profiles-page-section">
                        <Container className={"top-profiles-page-head"}>
                            <div>
                                <h1 className="line-heading">
                                    {intl.formatMessage({
                                        id: "portfolio.top_profiles.pole." + translationKey + ".title",
                                        defaultMessage: ""
                                    })}
                                </h1>

                                <p className="">
                                    {(locale === "fr") ? this.state.data?.hat_fr : this.state.data?.hat_en}
                                </p>

                                <div className="top-profiles-page-newsletter top-profiles-page-newsletter--mobile">
                                    <label>
                                        <FormattedMessage
                                            id="portfolio.top_profiles.newsletter.label"
                                            defaultMessage="Restez en alerte sur les top profils du mois"
                                        />
                                    </label>
                                    <Input className="input-field" id="email" onChange={(e) => this.setState({ email: e.target.value })}
                                           placeholder={intl.formatMessage({
                                               id: 'portfolio.top_profiles.newsletter.placeholder',
                                               defaultMessage: 'Entrez votre adresse email'
                                           })}
                                    />
                                    <div>
                                        <Button className="btn btn-primary" onClick={(e) => {this.mailTo(e)}} >
                                            <FormattedMessage
                                                id="portfolio.top_profiles.newsletter.cta"
                                                defaultMessage="Je m'abonne"
                                            />
                                        </Button>
                                    </div>
                                </div>

                                <div className="check-list">
                                    <label>
                                        <FormattedMessage
                                            id="portfolio.top_profiles.business_unit.label"
                                            defaultMessage="Sélectionnez un pôle"
                                        />
                                    </label>
                                    <ul>
                                        {this.state.ready && businessUnitOptions.map((option, key) => {
                                            if(!this.state.business_unit_options.includes(option.value)) {
                                                return
                                            }
                                            return (
                                                <li key={key}>
                                                    <BusinessUnitButton
                                                        prefix="/top-profiles/"
                                                        option={option}
                                                        state={this.state}
                                                    />
                                                </li>
                                            )
                                        })}
                                    </ul>
                                </div>
                            </div>
                            <div className="top-profiles-page-newsletter">
                                <label>
                                    <FormattedMessage
                                        id="portfolio.top_profiles.newsletter.label"
                                        defaultMessage="Restez en alerte sur les top profils du mois"
                                    />
                                </label>
                                <Input className="input-field" id="email" onChange={(e) => this.setState({ email: e.target.value })}
                                    placeholder={intl.formatMessage({
                                        id: 'portfolio.top_profiles.newsletter.placeholder',
                                        defaultMessage: 'Entrez votre adresse email'
                                    })}
                                />
                                <div>
                                    <Button className="btn btn-primary" onClick={(e) => {this.mailTo(e)}} >
                                        <FormattedMessage
                                            id="portfolio.top_profiles.newsletter.cta"
                                            defaultMessage="Je m'abonne"
                                        />
                                    </Button>
                                </div>
                            </div>
                        </Container>
                        <Container className={"top-profiles-page-profiles"}>
                            {(this.state.data?.top_profiles) &&
                                this.renderTopProfiles()
                            }
                        </Container>
                    </section>
            </div>
        )
    }
}

export default withRouter(injectIntl(TopProfilesPage));
